import classNames from 'classnames';
import { useDispatch } from 'react-redux';
import { Button } from 'palette/Button';
import { useModal } from 'palette/Modal';
import { useTranslation } from '@common/Hooks/useTranslation';
import { GA_SEARCH_CATEGORY, GA_SEARCH_OPEN_ACTION } from '@common/Tracking';
import { BEMBlock } from '@helpers/classnames';
import { pushGAEventToDataLayer } from '@helpers/dataLayer';
import { toggleSearchSidebarVisibility } from '../actions';
import { DESKTOP_SEARCH_MODAL_ID } from '../constants';
import { useSearchFocusOnClose } from '../hooks';
import '../styles/GlobalSearchHeaderContainer.scss';

export const toggleSearchBtnClassName = 'toggle-search-btn';

interface GlobalSearchHeaderContainerProps {
    theme: string;
    customClass?: string;
}

function GlobalSearchHeaderContainer({
    theme = 'light',
    customClass,
}: GlobalSearchHeaderContainerProps) {
    const { setIsSearchModalOpen, focusElementRef } = useSearchFocusOnClose();
    const dispatch = useDispatch();
    const { setActiveModalId } = useModal();
    const translate = useTranslation();
    const buttonTheme = theme === 'dark' ? 'dark' : 'secondary';
    const [block, BEMElement] = BEMBlock('global-search-header-container');

    const handleSearchButtonClick = () => {
        //  Window scroll required to fix iOS safari mobile keyboard content shift bug.
        window.scrollTo(0, 0);

        setIsSearchModalOpen(true);
        setActiveModalId(DESKTOP_SEARCH_MODAL_ID);

        pushGAEventToDataLayer(GA_SEARCH_CATEGORY, GA_SEARCH_OPEN_ACTION, '');
        dispatch(toggleSearchSidebarVisibility(true));
    };

    return (
        <div className={classNames(block, customClass)}>
            <Button
                ref={focusElementRef}
                isTransparent
                ariaLabel={translate('global_search_header')}
                className={BEMElement(toggleSearchBtnClassName)}
                iconName="palette_search"
                theme={buttonTheme}
                onClick={handleSearchButtonClick}
            />
        </div>
    );
}

export default GlobalSearchHeaderContainer;
